<template>
  <div class="br-subleft overflow-y-auto" :data-min="status">
    <h6
      class="tx-uppercase tx-10 tx-mont tx-spacing-1 mg-t-10 pd-x-10 tx-white-7"
    >
      {{ $t("warehouse.条件筛选") }}
    </h6>
    <div class="mg-t-10 pd-x-10 mg-b-40">
      <div class="mg-b-15 form-group">
        <input
          type="text"
          :placeholder="$t('product.商品名称')"
          class="form-control form-control-dark tx-14"
          @keyup.enter="filtrate()"
          v-model.trim="keyName"
        />
      </div>
      <div class="mg-b-15 form-group">
        <input
          type="text"
          :placeholder="$t('product.SKU 编号')"
          class="form-control form-control-dark tx-14"
          @keyup.enter="filtrate()"
          v-model.trim="keySku"
        />
      </div>
      <button
        class="
          btn btn-primary btn-block
          tx-uppercase tx-11 tx-spacing-2 tx-medium
        "
        @click="filtrate"
      >
        {{ $t("stockout.筛 选") }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["status", "key_name", "key_sku"],
  data() {
    return {
      keyName: "",
      keySku: "",
    };
  },
  watch: {
    key_name() {
      this.keyName = this.key_name;
    },
    key_sku() {
      this.keySku = this.key_sku;
    },
  },
  methods: {
    filtrate() {
      this.$parent.keyName = this.keyName;
      this.$parent.keySku = this.keySku;
      this.$parent.toPage(1);
    },
  },
};
</script>
